import { Routes } from '@angular/router';
import { CreditCardComponent } from "./credit-card.component";

export const CreditCardRoutes: Routes = [
    { path: '', component: CreditCardComponent, pathMatch: 'full' }
];

